import { sum, getJson, calculation, numConvert } from "@/method";

export default function ({
    roomData = [],
    foodData = [],
    dayData = [],
}) {

    // 计算餐饮收入
    ['actual', 'covers', 'last_actual', 'last_covers',].forEach(name => {
        foodData[10][name] = foodData.reduce((a, b, i) => {
            if (i < 10) a += numConvert(b[name]);
            return a;
        }, 0).toFixed(2);
    });

    foodData.forEach((item, i) => {
        foodData[i].average = calculation(item.actual, item.covers);
        foodData[i].last_average = calculation(item.last_actual, item.last_covers);
        if (i === 10) {
            foodData[i].average = calculation(item.actual - foodData[9].actual, item.covers);
            foodData[i].last_average = calculation(item.last_actual - foodData[9].last_actual, item.last_covers);
        }
    });


    // 计算客房
    ['actual', 'last'].forEach(name => {
        roomData[3][name] = calculation(roomData[2][name], roomData[1][name], 4);
        roomData[4][name] = calculation(roomData[6][name], roomData[2][name], 2);
        roomData[5][name] = (roomData[4][name] * roomData[3][name]).toFixed(2);
        roomData[8][name] = calculation(
            roomData[7][name],
            roomData[2][name], 4);
    });


    // 计算总收入
    dayData[0].rev_day = (numConvert(dayData[0].other_day) + numConvert(getJson([10, 'actual'], foodData)) + numConvert(getJson([6, 'actual'], roomData))).toFixed(2);
    dayData[0].rev_last = sum([
        dayData[0].other_last,
        getJson([10, 'last_actual'], foodData),
        getJson([6, 'last'], roomData),
    ], 2);

    return { roomData, foodData, dayData, }

}


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.1/compute.js